// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HorizontalGrid_wrapper__eiuEb","flexGrid":"HorizontalGrid_flexGrid__1oirR","margin":"HorizontalGrid_margin__Gx_Lf"};